import type { Breadcrumb } from '../infrastructure/pageTree';
import * as style from './Breadcrumbs.module.css';

export default function Breadcrumbs({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) {
    return (
        <nav className={style.breadcrumbs}>
            <ul>
                {breadcrumbs.map(({ _id, path, title }) => (
                    <li key={_id}>
                        <a href={path}>{title}</a>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
